<template>
  <svg :width="width" :height="height" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5 15.5C11.5 14.8411 11.2481 14.2597 10.7442 13.7558C10.2403 13.2519 9.65892 13 9 13C8.34108 13 7.75969 13.2519 7.25581 13.7558C6.75194 14.2597 6.5 14.8411 6.5 15.5C6.5 16.1589 6.75194 16.7403 7.25581 17.2442C7.75969 17.7481 8.34108 18 9 18C9.65892 18 10.2403 17.7481 10.7442 17.2442C11.2481 16.7403 11.5 16.1589 11.5 15.5ZM14.7558 17.2442C14.2519 16.7403 14 16.1589 14 15.5C14 14.8411 14.2519 14.2597 14.7558 13.7558C15.2597 13.2519 15.8411 13 16.5 13C17.1589 13 17.7403 13.2519 18.2442 13.7558C18.7481 14.2597 19 14.8411 19 15.5C19 16.1589 18.7481 16.7403 18.2442 17.2442C17.7403 17.7481 17.1589 18 16.5 18C15.8411 18 15.2597 17.7481 14.7558 17.2442ZM22.2558 17.2442C21.7519 16.7403 21.5 16.1589 21.5 15.5C21.5 14.8411 21.7519 14.2597 22.2558 13.7558C22.7597 13.2519 23.3411 13 24 13C24.6589 13 25.2403 13.2519 25.7442 13.7558C26.2481 14.2597 26.5 14.8411 26.5 15.5C26.5 16.1589 26.2481 16.7403 25.7442 17.2442C25.2403 17.7481 24.6589 18 24 18C23.3411 18 22.7597 17.7481 22.2558 17.2442Z"
      :fill="color"
    />
    <circle cx="16.5" cy="16" r="15" :stroke="color" stroke-width="2" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'OtherIcon',
  props: {
    width: {
      type: Number,
      default: 33,
    },
    height: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
